export default __webpack_public_path__ + "/dist/images/5028615.png";